export default "__VITE_ASSET__BYvU8FEl__"